import React from 'react';

interface HeroSectionProps {
  scrollToSection: (id: string) => void;
}

export default function HeroSection({ scrollToSection }: HeroSectionProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f1d1c56346f488bb2aa61b44c47b16a7.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      <div className="relative z-10 text-center px-6 w-full max-w-6xl mx-auto">
        <div className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-400/30 text-teal-300 text-sm font-semibold px-5 py-2 rounded-full mb-6">
          <i className="ri-shield-check-line text-lg"></i>
          Análise 100% Gratuita • Só Paga Se Ganhar
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-tight tracking-tight">
          Voo atrasado? Receba até<br />
          <span className="text-teal-400">R$ 15.000 de Indenização</span>
        </h1>

        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-4xl mx-auto leading-relaxed font-medium">
          Atraso acima de 4 horas, cancelamento ou bagagem extraviada?<br />
          <strong className="text-white">Descubra em 2 minutos se você tem direito — análise gratuita e sem compromisso.</strong>
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <button
            onClick={() => scrollToSection('contato')}
            className="group inline-flex items-center gap-4 bg-teal-500 hover:bg-teal-600 text-white px-12 py-6 rounded-full text-xl font-bold uppercase transition-all duration-300 hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-search-line text-2xl"></i>
            Quero Saber Se Tenho Direito
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </button>

          <a
            href="https://wa.me/5528998813826?text=Ol%C3%A1%2C%20meu%20voo%20teve%20um%20problema%20e%20quero%20saber%20se%20tenho%20direito%20a%20indeniza%C3%A7%C3%A3o.%20Pode%20me%20ajudar%3F"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white px-12 py-6 rounded-full text-xl font-bold uppercase transition-all duration-300 hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Falar Agora no WhatsApp
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 text-white/90 text-base font-medium">
          <span className="flex items-center gap-2">
            <i className="ri-check-double-line text-teal-400 text-xl"></i>
            Análise 100% gratuita
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-check-double-line text-teal-400 text-xl"></i>
            Sem compromisso
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-check-double-line text-teal-400 text-xl"></i>
            Só paga se ganhar
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-check-double-line text-teal-400 text-xl"></i>
            Resposta em até 24h
          </span>
        </div>
      </div>
    </section>
  );
}
